import { useContext } from "react";
import { Loading } from "wup-module1-base";
import UserContext from "../Contexts/UserContext";

function LoadingWrapper({ children }) {
  const { isLoading } = useContext(UserContext);

  return isLoading ? (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Loading variant="primary-purple" animation="grow" className="mx-2" />
      <Loading variant="primary-purple" animation="grow" className="mx-2" />
      <Loading variant="primary-purple" animation="grow" className="mx-2" />
    </div>
  ) : (
    children
  );
}

export default LoadingWrapper;
